<script setup>
import { onMounted } from "vue";
import { useGlobalStore } from "@stores/global";

const globalStore = useGlobalStore();

onMounted(() => {
    globalStore.openModal("sweepstakeIntro");
});
</script>

<template>
    <div class="contents"></div>
</template>
